import * as React from 'react';

function SvgArgentina(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 35 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path fill="#74ACDF" d="M0 0h35v21H0z" />
      <path fill="#fff" d="M0 7h35v8H0z" />
      <circle cx={18} cy={11} r={3} fill="#F6B40E" />
    </svg>
  );
}

export default SvgArgentina;
